import React from "react";
import { Link } from "react-router-dom";

export default function AppFooter() {
  return (
    <footer className="py-3 px-4 border-t border-line bg-white mt-auto">
      <div className="container mx-auto flex items-center justify-center gap-3 text-xs text-ink-soft">
        <span>© 2026 Golf Eclectic</span>
        <span className="text-line-strong">|</span>
        <Link to="/legal/privacy" className="hover:text-accent">Privacy Policy</Link>
        <span className="text-line-strong">|</span>
        <Link to="/legal/terms" className="hover:text-accent">Terms of Use</Link>
      </div>
    </footer>
  );
}
